export default {
    it: {
        "header": "Stai incontrando difficoltà e non sai cosa fare?",
        "body": "<div><p class='modal-large-p'>Puoi chiamarci tutti i giorni, dal lunedì al venerdì, dalle ore 12:00 alle ore 13:00 al numero:</p><p class='telephone-container modal-large-p'><a href='tel:0668825500'>06 68825500</a></p><p class='modal-large-p'>Un nostro operatore sarà lieto di accompagnarti nella compilazione.</p><div/>",
        "button":  "Nuova segnalazione/esposto",

    },
    en: {
        "header": "Stai incontrando difficoltà e non sai cosa fare?",
        "body": "<div><p>Puoi chiamarci tutti i giorni, dal lunedì al venerdì, dalle ore 12:00 alle ore 13:00 al numero:</p><p><a href='tel:0668825500'>06 68825500</a></p><p>Un nostro operatore sarà lieto di accompagnarti nella compilazione.</p><div/>",
        "button":  "Nuova segnalazione/esposto",
    }
}